//#region Imports

import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ToastModule } from 'primeng/toast';
import { IconComponent } from '../icon/icon.component';

//#endregion

@Component({
    selector: 'app-toast',
    templateUrl: './toast.component.html',
    imports: [
        ToastModule,
        IconComponent
    ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ToastComponent {}
